import React from "react";
import exclamationIcon from "@assets/images/icons/exclamation-mark.svg";
import { useTranslation } from "@helpers/translate";

export const renderValue = (value) => {
  const { __ } = useTranslation();
  
  if (!value || value === "") {
    return (
      <div
        className="profile-value-no-data"
        style={{ display: "flex", alignItems: "center", gap: "8px" }}
      >
        <img
          src={exclamationIcon}
          alt="warning"
          style={{ width: "14px", height: "14px" }}
        />
        <span>{__("common.no_data")}</span>
      </div>
    );
  }
  return value;
};